import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../useApiQuery';

const useGetNetwork = ({ networkId: propsNetworkId, disabled = false } = {}) => {
  const { networkId: paramNetworkId } = useParams();
  const networkId = paramNetworkId || propsNetworkId;

  const query = useApiQuery({
    queryKey: keys.network(networkId),
    requestUrl: `/networks/${networkId}`,
    disabled: !networkId || disabled,
  });

  return {
    network: query.data,
    isNetworkFetchError: query.isError,
    isNetworkFetchSuccess: query.isSuccess,
    isNetworkLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetNetwork;
